<template>
  <div class="wrap" :class="isSideMenuClosed ? 'collapsed' : ''">
    <!-- ヘッダー部分 -->
    <div class="header-individual" :class="header_notification ? 'header-notification-space' : ''">
      <div class="header-sns-wrap">
        <div class="header-sns youtube"><font-awesome-icon :icon="['fab', 'youtube']" /></div>
        <div class="header-sns-title">YouTube</div>
      </div>
    </div>
    <div class="header-individual" :class="header_notification ? 'header-notification-space' : ''" v-show="checkList.length > 0">
      <div>
        <div class="check-wrap">
          <div class="check-parts">{{ checkList.length }}名を選択中</div>
          <div class="check-parts pointer" @click="clearList"><i class="el-icon-remove-outline" style="font-size:14px;"></i>全員の選択を解除</div>
          <addListButton :checkList.sync="checkList" :checkAll_val.sync="checkAll_val" :sns_type="'youtube'" :other_sns_type="other_sns_type" />
        </div>
      </div>
    </div>

    <!-- ユーザーページ -->
    <div class="search-page-wrap">
      <div class="data-table-title">
        <div class="data-table-title-letter">
          インフルエンサー検索
          <div class="data-table-result-count">
            該当数<span class="data-table-result-count-num">{{ result_count }}</span
            >件
          </div>
        </div>
        <div class="flex-space"></div>
        <div class="data-table-menu">
          <windowSwitch />
          <el-dropdown :hide-on-click="false" trigger="click">
            <el-button type="info" style="margin-left:10px">
              表示項目
              <font-awesome-icon icon="caret-down" style="margin-left:5px" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item><el-checkbox v-model="item.channel_name" disabled>チャンネル名</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.sns">SNS</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.gender">性別</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.bio">チャンネル概要</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.subscriber">チャンネル登録者数</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.viewRate">視聴率</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.average_viewCount">平均視聴回数</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.egr">EGR</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.comments_count">平均コメント数</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.frequency">投稿頻度</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.likeCount">平均高評価数</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.pr_rate">PR率</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.gender_ratio">フォロワー男女比</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.main_audience">フォロワー年齢層</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.tag">カスタマイズタグ</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.recent_post">直近の投稿</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.created_at">追加日</el-checkbox></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <!-- データテーブル全体 -->
      <!-- テーブルタイトル -->
      <div class="data-table">
        <div class="data-table-th" :class="header_notification ? 'header-notification-space-120' : ''">
          <div class="data-table-th-background" :style="'width:' + data_table_width"></div>
          <div class="data-table-th-account youtube">
            <div class="data-table-th-checkbox">
              <el-checkbox v-model="checkAll_val" @change="checkAll" v-show="!noinfluencer"></el-checkbox>
            </div>
            <div class="data-table-th-picture_name pointer data-table-th-line" id="item_channel_name" :style="'min-width:' + account_name_width">
              <span class="data-table-underline">チャンネル名</span>
            </div>
          </div>
          <div class="data-table-th-sns data-table-th-line" v-show="item.sns" id="item_sns">SNS</div>
          <div class="data-table-th-usergender data-table-th-line" v-show="item.gender" id="item_gender">性別</div>
          <div class="data-table-th-usergender data-table-th-line" v-if="item.gender && activate == 20 && admin_mode" id="item_gender">TP</div>
          <div class="data-table-th-bio data-table-th-line" v-show="item.bio" id="item_bio" :style="'max-width:' + max_width">チャンネル概要</div>
          <tableColumn :item="'subscriber'" :column="'subscriberCount'" :css="'num'" :title="'チャンネル\n登録者数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'viewRate'" :column="'viewRate'" :css="'eg youtube'" :title="'視聴率'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'average_viewCount'" :column="'average_viewCount'" :css="'num'" :title="'平均視聴回数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'egr'" :column="'average_engagement_rate'" :css="'eg youtube'" :title="'EGR'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'comments_count'" :column="'average_comments_count'" :css="'eg youtube'" :title="'平均\nコメント数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'frequency'" :column="'frequency'" :css="'eg youtube'" :title="'投稿\n頻度'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'likeCount'" :column="'likeCount'" :css="'eg youtube'" :title="'平均\n高評価数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'pr_rate'" :column="'prRate'" :css="'eg youtube'" :title="'PR率'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'gender_ratio'" :column="'female_ratio'" :css="'gender'" :title="'フォロワー\n男女比'" :item_info="item_info" @sortBy="sortBy" />
          <div class="data-table-th-num" v-if="item.main_audience" id="item_main_audience">フォロワー<br />年齢層</div>
          <div class="data-table-th-tag" v-show="item.tag" id="item_tag">カスタマイズタグ</div>
          <div class="data-table-th-photo youtube data-table-th-line" v-if="y_search.category || (y_search.keyword && item.recent_post && y_search.keyword.trim() !== '')" id="item_recent_post">
            {{ y_search.keyword ? "「" + y_search.keyword + "」の関連" : y_search.category + "の" }}投稿
          </div>
          <div class="data-table-th-photo youtube data-table-th-line" v-else v-show="item.recent_post" id="item_recent_post">直近の投稿</div>
          <div
            class="data-table-th-ranking pointer data-table-th-line"
            v-show="y_search.keyword && y_search.keyword.trim() !== ''"
            @click="sortBy('keyword')"
            :class="[sort_key === 'keyword' ? 'data-table-sort-active' : '']"
            id="item_ranking"
          >
            <span class="data-table-underline"> 「{{ y_search.keyword }}」 <br />との関連度 </span>
            <font-awesome-icon v-show="sort_key == 'keyword'" :icon="sort_order == 'asc' ? 'arrow-up' : 'arrow-down'" style="margin-left:3px;"  />
          </div>
          <tableColumn :item="'created_at'" :column="'created_at'" :css="'140'" :title="'追加日'" :item_info="item_info" @sortBy="sortBy" />
          <div class="data-table-th-category" v-show="item.category" id="item_category">関連カテゴリ</div>
        </div>

        <!-- テーブルループ -->
        <transition name="fade" v-if="noindex">
          <div class="data-table-list-nolist">
            <img src="../../assets/time.png" style="opacity:0.5" alt />
            <div style="font-size:20px; font-weight:700; margin-bottom:20px; text-align: center;">
              こちらのキーワード検索は、初回のみ時間がかかります。<br>
              5~10分後に、同じキーワードで再検索をお願いします。
            </div>
            <div class="flex-row" style="margin-bottom: 10px;">
              <div class="loader--mini blue"></div>
            </div>
            <div class="flex-row" style="margin-bottom: 20px;">
              <div v-if="index_create_progress == 10" class="flex-row" style="margin-left: 10px;">「{{ y_search.keyword }}」に関する投稿データを収集しています...</div>
              <div v-else-if="index_create_progress > 10">「{{ y_search.keyword }}」の関連度を計算しています...</div>
            </div>
            <div>
              <a href="https://help.reech.co.jp/ja/articles/5938435" target="_blank" class="router-link"
                >キーワード検索に時間がかかる理由は？ <font-awesome-icon :icon="['far', 'external-link']" style="margin-left: 3px;"
              /></a>
            </div>
          </div>
        </transition>
        <div class="data-table-list-nolist" v-else-if="noinfluencer">
          <img src="../../assets/search_image.png" style="opacity:0.5" alt />
          <div style="font-size:20px; font-weight:700; margin-bottom:10px;">インフルエンサーが見つかりませんでした</div>
          <div style="margin-bottom: 30px;">条件を変えて検索してみましょう</div>
        </div>
        <div class="data-table-tr" v-for="(influencer, index) in list.influencer" :key="influencer.channel_id">
          <div class="data-table-tr-background" :style="'width:' + data_table_width"></div>
          <div class="data-table-th-account youtube">
            <div class="data-table-th-checkbox">
              <input type="checkbox" class="checkbox-original" v-model="checkList" :value="influencer.channel_id" :id="influencer.channel_id + 'checkbox'" />
              <label class="checkbox_inner" :for="influencer.channel_id + 'checkbox'"> </label>
            </div>
            <div class="data-table-th-picture pointer">
              <favorite :favorite="influencer.favorite" :index="index" @changeFavorite="changeFavorite" />
              <img
                :src="influencer.thumbnails"
                class="data-table-profile"
                @click.exact="window_switch ? openDrawer(influencer.channel_id, index, 'youtube', false) : openNewWindow(influencer.channel_id, 'youtube')"
                @click.ctrl.exact="openNewWindow(influencer.channel_id, 'youtube')"
                @click.meta.exact="openNewWindow(influencer.channel_id, 'youtube')"
                @error="imgError(index)"
              />
            </div>
            <div class="data-table-th-account-name youtube pointer" id="item_tr_name">
              <div
                @click.exact="window_switch ? openDrawer(influencer.channel_id, index, 'youtube', false) : openNewWindow(influencer.channel_id, 'youtube')"
                @click.ctrl.exact="openNewWindow(influencer.channel_id, 'youtube')"
                @click.meta.exact="openNewWindow(influencer.channel_id, 'youtube')"
                class="badge-wrap"
              >
                {{ influencer.channel_name }}
                <img src="../../assets/badge.png" style="width:14px; height:14px; margin-left:5px" v-show="influencer.badge == '1'" />
              </div>
              <div class="data-table-th-listname" v-if="influencer.list_count > 0">
                <listIn :list_in="influencer.list_in" :list_count="influencer.list_count" v-show="permission.list.access" />
              </div>
            </div>
          </div>
          <div class="data-table-th-sns" v-show="item.sns">
            <snsIconList :other_sns="influencer.other_sns" />
          </div>
          <div class="data-table-th-usergender" v-if="item.gender && activate == 20 && admin_mode">
            <div class="pointer" @click="changeGender('nodisplay', influencer.channel_id, index)" :class="influencer.gender == 'nodisplay' ? 'danger' : ''">非表示</div>
            <div class="pointer" @click="changeGender('', influencer.channel_id, index)" :class="influencer.gender == '' ? 'active null' : ''">未設定</div>
            <div class="pointer" @click="changeGender('女性', influencer.channel_id, index)" :class="influencer.gender == '女性' ? 'active' : ''">女性</div>
            <div class="pointer" @click="changeGender('男性', influencer.channel_id, index)" :class="influencer.gender == '男性' ? 'active' : ''">男性</div>
            <div class="pointer" @click="changeGender('グループ', influencer.channel_id, index)" :class="influencer.gender == 'グループ' ? 'active' : ''">グループ</div>
            <div class="pointer" @click="changeGender('その他', influencer.channel_id, index)" :class="influencer.gender == 'その他' ? 'active' : ''">その他</div>
          </div>
          <div class="data-table-th-usergender" v-if="item.gender && activate == 20 && admin_mode">{{ influencer.gender_tp }}</div>
          <div class="data-table-th-usergender" v-if="item.gender && !admin_mode">{{ influencer.gender }}</div>
          <div class="data-table-th-bio" v-show="item.bio" :style="'max-width:' + max_width">
            <pre><span v-html="$options.filters.searchHighlight(influencer.description, y_search.keyword)"></span></pre>
          </div>
          <div class="data-table-th-num" v-show="item.subscriber">{{ influencer.hiddenSubscriberCount == 1 ? "非公開" : influencer.subscriberCount }}</div>
          <div class="data-table-th-eg youtube" v-show="item.viewRate">{{ influencer.hiddenSubscriberCount == 1 ? "-" : influencer.average_viewRate_3month + "%" }}</div>
          <div class="data-table-th-num" v-show="item.average_viewCount">{{ influencer.average_viewCount_3month | addComma }}</div>
          <div class="data-table-th-eg youtube" v-show="item.egr">{{ influencer.hiddenSubscriberCount == 1 ? "-" : influencer.average_engagementRate_subscriber_3month + "%" }}</div>
          <div class="data-table-th-eg youtube" v-show="item.comments_count">{{ influencer.average_commentCount_3month | addComma }}</div>
          <div class="data-table-th-eg youtube" v-show="item.frequency">{{ influencer.average_postCount_week }}</div>
          <div class="data-table-th-eg youtube" v-show="item.likeCount">{{ influencer.average_likeCount_3month | addComma }}</div>
          <div class="data-table-th-eg youtube" v-show="item.pr_rate">{{ influencer.prRate }}%</div>
          <div class="data-table-th-gender" v-show="item.gender_ratio"><genderRatio :female_ratio="influencer.female_ratio" :male_ratio="influencer.male_ratio" /></div>
          <div class="data-table-th-num" v-show="item.main_audience">
            <div v-if="influencer.main_audience">
              {{ influencer.main_audience }}<span class="data-table-main-audience-percent">{{ influencer.main_audience_percent }}%</span>
            </div>
            <div v-else>-</div>
          </div>
          <div class="data-table-th-tag" v-show="item.tag">
            <customizeTag :id="influencer.channel_id" :sns_type="'youtube'" :tags="influencer.tags" :influencer_index="index" @updateTag="updateTag" />
          </div>
          <div class="data-table-th-photo youtube hover pointer" v-show="item.recent_post" @click="openDrawer(influencer.channel_id, index, 'youtube', true)">
            <div class="category">
              <div class="category-box-photoarea youtube" v-for="video in influencer.category_post" :key="video.id">
                <img v-show="video" :src="'https://i.ytimg.com/vi/' + video + '/default.jpg'" alt class="category-box-img youtube" />
              </div>
            </div>
          </div>
          <div class="data-table-th-140" v-show="item.created_at">{{ influencer.created_at }}</div>
          <div class="data-table-th-ranking" v-if="y_search.keyword && y_search.keyword.trim() !== ''">
            <div class="category">
              <div class="data-table-th-ranking-box">
                <div class="data-table-th-ranking-bar" :style="'width:' + influencer.ranking + '%'"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <infinite-loading spinner="spiral" :identifier="infiniteId" @infinite="infiniteHandler">
        <div slot="no-more" style="font-size:40px;"></div>
        <div slot="no-results" style="font-size:40px;"></div>
      </infinite-loading>
      <div v-bind:class="[drawer ? 'i-detail-modal open' : 'i-detail-modal']" id="i-detail-scroll">
        <router-view
          ref="iDetail"
          v-show="drawer"
          @favoriteReactive="favoriteReactive"
          @addInfluencerReactive="addInfluencerReactive"
          @deleteInfluencerReactive="deleteInfluencerReactive"
          @tagReactive="tagReactive"
        ></router-view>
      </div>
      <div class="overlay" v-bind:class="[drawer ? 'overlay open' : 'overlay']" @click="closeDrawer"></div>
    </div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const YsearchAPI = root + "/api/search/search_youtube";
const checkIndexProgressAPI = root + "/api/search/check";
const addFavoriteAPI = root + "/api/list/add_favorite";
const changeGenderAPI = root + "/api/admin/change_gender";
import favorite from "../list/favorite";
import genderRatio from "../list/gender_ratio";
import listIn from "../list/list_in";
import addListButton from "../list/add_list_button";
import tableColumn from "./table_column";
import windowSwitch from "../list/window_switch";
import snsIconList from "./sns_icon_list.vue";
import customizeTag from "./customize_tag";

export default {
  name: "YouTuber",
  components: {
    favorite,
    genderRatio,
    listIn,
    addListButton,
    tableColumn,
    windowSwitch,
    snsIconList,
    customizeTag,
  },
  data() {
    return {
      list: [],
      count: 0,
      result_count: 0,
      category: "",
      sort_key: "",
      sort_order: "",
      infiniteId: +new Date(),
      checkList: [],
      checkAll_val: false,
      checkedCount: 0,
      noinfluencer: false,
      noindex: false,
      index_create_progress: 0,
      default_search: false,
      search_type: "",
      drawer: false,
      item: {
        channel_name: true,
        gender: false,
        sns: true,
        subscriber: true,
        average_viewCount: true,
        comments_count: true,
        viewRate: true,
        egr: true,
        pr_rate: true,
        gender_ratio: true,
        frequency: false,
        likeCount: true,
        recent_post: true,
      },
      router_link: "",
      data_table_width: "",
      max_width: "100%",
      account_name_width: "",
      search_dropdown: "",
      search_dropdown_regexp: "",
      search_dropdown_add: "",
      search_dropdown_add_regexp: "",
      requestId: 0,
      intervalId: null,
      other_sns_type: "",
      mountedLoad: false,
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    permission() {
      return this.$store.state.permission;
    },
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    activate() {
      return this.$store.state.activate;
    },
    form_youtube() {
      return this.$store.state.form_youtube;
    },
    y_search() {
      return this.$store.state.y_search;
    },
    window_switch() {
      return this.$store.state.window_switch;
    },
    header_notification() {
      return this.$store.state.header_notification;
    },
    item_info() {
      var info = {
        item: this.item,
        sort_key: this.sort_key,
        sort_order: this.sort_order,
      };
      return info;
    },
    isSideMenuClosed() {
      return this.$store.state.isSideMenuClosed;
    },
  },
  mounted() {
    this.$store.dispatch("changeActive", "y_search");
    window.addEventListener("resize", this.calcWidth);
    // mounted時のみform_youtubeが更新されたらリロードを行う為のフラグ
    this.mountedLoad = true;
  },
  methods: {
    loadQuery() {
      this.infiniteId += 1;
      this.scrollTop();
      this.sort_order = "desc";
      this.sort_key = "subscriberCount";
      if (this.y_search.keyword != "") {
        this.sort_order = "desc";
        this.sort_key = "keyword";
      }
      if (this.y_search.gender_null) {
        this.item.gender = true;
        this.item.created_at = true;
        this.sort_key = "created_at";
      }
      if (this.y_search.main_audience) this.item.main_audience = true;
      if (this.y_search.tags && this.y_search.tags.length) this.item.tag = true;
      this.default_search = false;
      this.list = [];
      this.checkList = [];
      this.checkAll_val = false;
      this.count = 0;
      this.result_count = 0;
      this.other_sns_type = this.y_search.other_sns_type;
    },
    infiniteHandler($state) { 
      
      // パラメータがセットされていない場合はリクエストをしない
      if(Object.keys(this.y_search).length === 0) return;
      
      this.noinfluencer = false;
      this.noindex = false;
      this.axios.cancel(this.requestId);
      this.requestId += 1;
      var params = new URLSearchParams();
      params.append("params", JSON.stringify(this.y_search));
      params.append("count", this.count);
      params.append("sort_key", this.sort_key);
      params.append("sort_order", this.sort_order);
      params.append("user_token", this.user_token);
      params.append("token", this.token);
      this.axios
        .post(YsearchAPI, params, { requestId: this.requestId })
        .then((response) => {
          this.cancelSource = null;
          if (this.count == 0) {
            this.result_count = response.data.result_count;
            this.list = response.data;
            this.count += 20;
            $state.loaded();
            this.$nextTick(() => {
              this.calcWidth(); //テーブルの横サイズを取得
            });
          } else {
            var newinfluencer = this.list.influencer.concat(response.data.influencer);
            this.list.influencer = newinfluencer;
            this.count += 20;
            $state.loaded();
          }
          if (this.count >= this.result_count) $state.complete();
          if (this.result_count == 0) this.noinfluencer = true;
          if (response.data.noindex) {
            this.noindex = true;
            this.index_create_progress = response.data.index_create_progress;
          }
        })
        .catch(() => {});
    },
    sortBy(value) {
      if (this.sort_key != value) {
        this.sort_order = "desc";
      } else {
        if (this.sort_order == "") {
          this.sort_order = "desc";
        } else if (this.sort_order == "asc") {
          this.sort_order = "desc";
        } else {
          this.sort_order = "asc";
        }
      }
      this.sort_key = value;
      this.list = [];
      this.count = 0;
      this.infiniteId += 1;
    },
    clearList() {
      this.checkAll_val = false;
      this.checkList = [];
    },
    checkAll(val) {
      const allInfluencer = [];
      for (let i = 0; i < this.list.influencer.length; i++) {
        allInfluencer[i] = this.list.influencer[i].channel_id;
      }
      this.checkList = val ? allInfluencer : [];
    },
    toSetting() {
      this.$router.push("/setting");
    },
    openDrawer(value, index, sns_type, default_search) {
      if (this.y_search.keyword) {
        this.search_type = "keyword";
        var search_keyword = this.y_search.keyword;
      } else {
        this.search_type = "all";
        search_keyword = "";
      }
      this.drawer = true;
      document.documentElement.style.overflow = "hidden";
      this.$router.push({
        name: sns_type == "youtube" ? "youtube_youtuberDetailDrawer" : "youtube_influencerDetailDrawer",
        params: {
          channel_id: value,
          influencer_index: index,
          parent_component: "youtube",
          child: true,
          default_search: default_search,
          search_keyword: search_keyword,
          search_type: default_search ? this.search_type : "all",
        },
      });
    },
    openNewWindow(value, sns_type) {
      let routeData = this.$router.resolve({
        name: sns_type == "instagram" ? "influencerDetail" : "youtuberDetail",
        params: {
          channel_id: value,
          account_name: value,
          child: false,
        },
      });
      window.open(routeData.href, "_blank");
    },
    closeDrawer() {
      this.drawer = false;
      document.documentElement.style.overflow = "auto";
      // this.$refs.iDetail.closeParentDrawer();
      this.$router.push({
        name: "youtuber",
        params: {
          backpage: true,
        },
      });
    },
    changeGender(command, channel_id, index) {
      this.axios.get(changeGenderAPI, {
        params: {
          id: channel_id,
          sns_type: "youtube",
          gender: encodeURI(command == "" ? "null" : command),
          token: this.token,
        },
      });
      this.list.influencer[index].gender = command;
    },
    changeFavorite(index) {
      if (this.list.influencer[index].favorite == 0) {
        this.list.influencer[index].favorite = 1;
      } else {
        this.list.influencer[index].favorite = 0;
      }
      var params = new URLSearchParams();
      params.append("influencer", this.list.influencer[index].channel_id);
      params.append("sns_type", "youtube");
      params.append("favorite", this.list.influencer[index].favorite);
      params.append("token", this.token);
      this.axios.post(addFavoriteAPI, params);
    },
    favoriteReactive(index, favorite) {
      this.list.influencer[index].favorite = favorite;
    },
    addInfluencerReactive(index, list_name, list_id) {
      let object = {
        list_name: list_name,
        list_id: list_id,
      };
      if (this.list.influencer[index]) {
        if (!this.list.influencer[index].list_in) {
          this.list.influencer[index].list_in = [];
        }
        this.list.influencer[index].list_in.push(object);
        this.list.influencer[index].list_count += 1;
      }
    },
    deleteInfluencerReactive(index, list_id) {
      if (this.list.influencer[index]) {
        let list_in = this.list.influencer[index].list_in;
        for (let i = 0; i < list_in.length; i++) {
          if (list_in[i].list_id == list_id) {
            this.list.influencer[index].list_in.splice(i, 1);
          }
        }
        this.list.influencer[index].list_count -= 1;
      }
    },
    updateTag(type, tag_index, new_tag, influencer_index) {
      if (type == "add") {
        this.list.influencer[influencer_index].tags.push(new_tag);
      } else if (type == "delete") {
        this.list.influencer[influencer_index].tags.splice(tag_index, 1);
      }
    },
    tagReactive(id, type, tag_index, new_tag) {
      var id_type = "channel_id";
      for (let i = 0; i < this.list.influencer.length; i++) {
        if (this.list.influencer[i][id_type] == id) {
          if (type == "add") {
            this.list.influencer[i].tags.push(new_tag);
          } else if (type == "delete") {
            this.list.influencer[i].tags.splice(tag_index, 1);
          }
        }
      }
    },
    calcWidth() {
      const account_width = this.result_count > 0 ? document.getElementById("item_tr_name").getBoundingClientRect().width : 0;
      this.account_name_width = account_width + 80 + "px";
      let sum = 0;
      for (let key of Object.keys(this.item)) {
        const width = document.getElementById("item_" + key) ? document.getElementById("item_" + key).getBoundingClientRect().width : 0;
        sum += width;
      }
      this.data_table_width = sum + 80 + "px";
    },
    windowSwitch() {
      this.$store.dispatch("windowSwitch");
    },
    scrollTop() {
      window.scroll({ top: 0, behavior: "instant" });
    },
    searchDropdown(value) {
      this.search_dropdown_regexp = new RegExp(value, "ig");
    },
    searchDropdownAdd(value) {
      this.search_dropdown_add_regexp = new RegExp(value, "ig");
    },
    imgError(index) {
      this.list.influencer[index].thumbnails = this.s3BaseUrl + "/userdata/img_error.png";
    },
    checkIndexProgressInterval() {
      clearInterval(this.intervalId);
      this.intervalId = setInterval(this.checkIndexProgress, 5000);
    },
    checkIndexProgress() {
      this.axios
        .get(checkIndexProgressAPI, {
          params: {
            search_keyword: this.y_search.keyword,
            target_type: "influencer",
            sns_type: "youtube",
          },
        })
        .then((response) => {
          this.index_create_progress = response.data.index_create_progress;
          if (this.index_create_progress == 100) {
            clearInterval(this.intervalId);
            this.list = [];
            this.count = 0;
            this.infiniteId += 1;
          }
        })
        .catch(() => {});
    },
  },
  destroyed() {
    window.removeEventListener("resize", this.calcWidth);
    clearInterval(this.intervalId);
  },
  watch: {
    $route(to) {
      clearInterval(this.intervalId);
      if (to.name == "youtuber" && !this.$route.params.backpage) {
        this.drawer = false;
        this.loadQuery();
      }
    },
    item: {
      handler() {
        this.$nextTick(() => {
          this.calcWidth();
        });
      },
      deep: true,
    },
    noindex() {
      if (this.noindex) {
        this.checkIndexProgressInterval();
      } else {
        clearInterval(this.intervalId);
      }
    },
    form_youtube() {            
      // mounted時のみform_youtubeが更新かつパラメータがセットされていたらリロードを行う。
      let form_length = Object.keys(this.form_youtube).length;      
      if(form_length >= 20 && this.mountedLoad === true) {
        this.$store.dispatch("y_search", this.form_youtube);
        this.loadQuery();  
        this.mountedLoad = false;
      }
    }
  },
  filters: {
    searchHighlight(value, keyword) {
      if (keyword) {
        const keyword_rep1 = keyword.replace(/OR/g, "|");
        const keyword_rep2 = keyword_rep1.replace(/"/g, "");
        const keyword_rep3 = keyword_rep2.replace(/\s/g, "|");
        const keyword_RegExp = new RegExp(keyword_rep3, "ig");
        return value.replace(keyword_RegExp, (keyword) => '<span class="data-table-th-highlight">' + keyword + "</span>");
      }
      return value;
    },
    addComma(val) {
      return Math.floor(val).toLocaleString();
    },
  },
};
</script>
